// extracted by mini-css-extract-plugin
export default {"search":"searchInput_search__hEj5U","searchFocused":"searchInput_searchFocused__Gy4Gq"};